import React, { Component } from 'react';
import { Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripLines } from '@fortawesome/free-solid-svg-icons'
import PortalAccountOverview from '../Library/PortalAccountOverview'
import PortalAccountSummary from '../Library/PortalAccountSummary'
import PortalFixedIncomeHoldings from '../Library/PortalFixedIncomeHoldings'
import PortalHoldings from '../Library/PortalHoldings'
import PortalPerformanceOverview from '../Library/PortalPerformanceOverview'
import PortalRealizedGains from '../Library/PortalRealizedGains'
import PortalTransactionSummary from '../Library/PortalTransactionSummary'
import LandingActiveCampaigns from '../Library/LandingActiveCampaigns'
import LandingMyFavorites from '../Library/LandingMyFavorites';
import LandingRecentActivity from '../Library/LandingRecentActivity';
import LandingToDos from '../Library/LandingToDos';
import LandingMyOpportunities from '../Library/LandingMyOpportunities';
import * as utilities from '../../../utilities';
import 'bootstrap/dist/css/bootstrap.css';
import './Dashboards.css'

class DashboardTile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            width: this.props.width,
            height: 1,
            callback: null,
        };
    }

    filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        const content = row[id];
        if (typeof content !== 'undefined') {
            // filter by text in the table or if it's a object, filter by key
            if (typeof content === 'object' && content !== null && content.key) {
                return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
            } else {
                return String(content).toLowerCase().includes(filter.value.toLowerCase());
            }
        }
        return true;
    };

    formatDate = (d) => {
        if (d == null || d === '' || parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    getWidthName = (width) => {
        utilities.log('DashboardTile.js/getWidthName (width)', width);
        switch (width) {
            case 4: return "Small";
            case 6: return "Medium";
            case 12: return "Large";
            default: return "";
        }
    }

    getModule = (module, icon) => {
        utilities.log('DashboardTile.js/getWidthName (module)', module);
        if (!this.props.handleChange) icon = null;
        switch (module) {
            case "AccountOverview":
                return <PortalAccountOverview
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    callback={this.callback}
                    icon={icon}
                />
            case "AccountSummary":
                return <PortalAccountSummary
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    callback={this.callback}
                    icon={icon}
                />
            case "Holdings":
                return <PortalHoldings
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    callback={this.callback}
                    icon={icon}
                />
            case "FixedIncomeHoldings":
                // return null
                return <PortalFixedIncomeHoldings
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    callback={this.callback}
                    icon={icon}
                />
            case "RealizedGains":
                return <PortalRealizedGains
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    callback={this.callback}
                    icon={icon}
                />
            case "TransactionSummary":
                return <PortalTransactionSummary
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    callback={this.callback}
                    icon={icon}
                />
            case "PerformanceOverview":
                return <PortalPerformanceOverview
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    callback={this.callback}
                    icon={icon}
                />
            case "ActiveCampaigns":
                return <LandingActiveCampaigns
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    callback={this.callback}
                    icon={icon}
                />
            case "MyFavorites":
                return <LandingMyFavorites
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    callback={this.callback}
                    icon={icon}
                />
            case "RecentActivities":
                return <LandingRecentActivity
                    {...this.props}
                    callback={this.callback}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    icon={icon}
                />
            case "CampaignToDos":
                return <LandingToDos
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    icon={icon}
                    callback={this.callback}
                />
            case "MyOpportunities":
                return <LandingMyOpportunities
                    {...this.props}
                    formatDate={this.formatDate}
                    filterCaseInsensitive={this.filterCaseInsensitive}
                    icon={icon}
                    callback={this.callback}
                />
            default:
                return <>Module {module}</>
        }
    }

    callback = (cb) => {
        utilities.log('DashboardTile.js/callback (cb)', cb);
        this.setState({
            callback: cb
        });
    }

    render() {
        utilities.info('DashboardTile.js/render');
        const moduleOutput = this.getModule(
            this.props.dashboardTile.Module,
            <div className="dragIcon px-2"><FontAwesomeIcon icon={faGripLines} /></div>
        );

        const isEmptyFragment =
            React.isValidElement(moduleOutput) &&
            moduleOutput.type === React.Fragment &&
            React.Children.count(moduleOutput.props.children) === 0;
        const shouldHideTile =
            moduleOutput == null ||
            moduleOutput === false ||
            moduleOutput === '' ||
            isEmptyFragment;

        if (shouldHideTile) return null;

        return (
            <Col md={this.props.width} className={"dashboardTile px-2 pb-3" + (this.props.active ? "" : " d-none")}>
                {moduleOutput}
            </Col>
        );
    }
}

export default DashboardTile;
